var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"bg-image",attrs:{"src":"assets/images/stormy-seas-4.jpg","height":"100vh"}})}
var staticRenderFns = []

export { render, staticRenderFns }